import React from "react";
import "../App.css";
import Layout from "./common/Layout";

const WelcomePage = () => {
    return <Layout pageName="sidenav">
        <div>
            <ul className="nav nav-pills ms-56 p-30" role="tablist" >
                <li className="nav-item">
                    <a className="nav-link fs-12 active me-8" data-bs-toggle="pill" href="#nav-1">Apps</a>
                </li>
               
            </ul>
            <div className="tab-content p-30">
                <div id="nav-1" className=" ms-56 tab-pane active">
                    <div className="d-flex flex-wrap">
                        <div className="card mb-16 border-0 me-16">

                            <div className="d-flex mb-10 justify-content-between">
                                <h5 className="d-flex align-items-center m-0 fw-bold">Flex
                                </h5>


                            </div>
                            <p className="fs-12 h-80">A customisable business chatbot platform that offers greater user engagement.

                            </p>
                            <div className="d-flex justify-content-end">
                                <a href="https://flex.appgallery.ai/signin/1" className="text-dark fw-bold  fs-14" target="_blank">Live Demo</a>
                            </div>
                        </div>
                        <div className="card mb-16 border-0 me-16">

                            <div className="d-flex mb-10 justify-content-between">
                                <h5 className="d-flex align-items-center m-0 fw-bold">Elevate
                                </h5>


                            </div>
                            <p className="fs-12 h-80">Elevate offers tailor-made chatbots designed for seamless integration into your internal workflows and customer service, ensuring your data remains private and secure.

                            </p>
                            <div className="d-flex justify-content-end">
                                <a href="https://elevate.appgallery.ai/signin/1" className="text-dark fw-bold  fs-14" target="_blank">Live Demo</a>
                            </div>
                        </div>
                        <div className="card mb-16 border-0 me-16">

                            <div className="d-flex mb-10 justify-content-between">
                                <h5 className="d-flex align-items-center m-0 fw-bold">Grasp
                                </h5>


                            </div>
                            <p className="fs-12 h-80">An AI document and image reader that streamlines data transformation.

                            </p>
                            <div className="d-flex justify-content-end">
                                <a href="https://docreader.appgallery.ai/" className="text-dark fw-bold  fs-14" target="_blank">Live Demo</a>
                            </div>
                        </div>

                        <div className="card mb-16 border-0 me-16">

                            <div className="d-flex mb-10 justify-content-between">
                                <h5 className="d-flex align-items-center m-0 fw-bold">Steno
                                </h5>


                            </div>
                            <p className="fs-12 h-80">An AI-powered translator plugin that eliminates language barriers.

                            </p>
                            <div className="d-flex justify-content-end">
                                <a href="https://steno.appgallery.ai/" className="text-dark fw-bold  fs-14" target="_blank">Live Demo</a>
                            </div>
                        </div>
                        <div className="card mb-16 border-0 me-16">

                            <div className="d-flex mb-10 justify-content-between">
                                <h5 className="d-flex align-items-center m-0 fw-bold">Collab
                                </h5>


                            </div>
                            <p className="fs-12 h-80">An AI-embedded collaboration portal helping communities of users.

                            </p>
                            <div className="d-flex justify-content-end">
                                <a href="#" className="text-dark fw-bold  fs-14" target="_blank">Live Demo</a>
                            </div>
                        </div>
                        <div className="card mb-16 border-0 me-16">

                            <div className="d-flex mb-10 justify-content-between">
                                <h5 className="d-flex align-items-center m-0 fw-bold">Social
                                </h5>


                            </div>
                            <p className="fs-12 h-80">Connect Privately, Share Securely: Your Exclusive Community Space.



                            </p>
                            <div className="d-flex justify-content-end">
                                <a href="" className="text-dark fw-bold  fs-14" target="_blank">Live Demo</a>
                            </div>
                        </div>


                        {/* <div className="card mb-16 border-0 me-16">
                            <div className="d-flex mb-10">
                                <img src="avatar_icon.jpg" alt="user-image" width="37" height="37"
                                    className="rounded-circle me-13" />
                                <h5 className="d-flex align-items-center m-0">Procure AI</h5>
                            </div>
                            <p className="fs-12">It is a long established fact that a reader will be distracted by the
                                readable content of a page when
                                looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less
                                normal
                                distribution of letters, as opposed to using</p>
                        </div>
                        <div className="card mb-16 border-0 me-16">
                            <div className="d-flex mb-10">
                                <img src="avatar_icon.jpg" alt="user-image" width="37" height="37"
                                    className="rounded-circle me-13" />
                                <h5 className="d-flex align-items-center m-0">Procure AI</h5>
                            </div>
                            <p className="fs-12">It is a long established fact that a reader will be distracted by the
                                readable content of a page when
                                looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less
                                normal
                                distribution of letters, as opposed to using</p>
                        </div>
                        <div className="card mb-16 border-0 me-16">
                            <div className="d-flex mb-10">
                                <img src="avatar_icon.jpg" alt="user-image" width="37" height="37"
                                    className="rounded-circle me-13" />
                                <h5 className="d-flex align-items-center m-0">Procure AI</h5>
                            </div>
                            <p className="fs-12">It is a long established fact that a reader will be distracted by the
                                readable content of a page when
                                looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less
                                normal
                                distribution of letters, as opposed to using</p>
                        </div>
                        <div className="card mb-16 border-0 me-16">
                            <div className="d-flex mb-10">
                                <img src="avatar_icon.jpg" alt="user-image" width="37" height="37"
                                    className="rounded-circle me-13" />
                                <h5 className="d-flex align-items-center m-0">Procure AI</h5>
                            </div>
                            <p className="fs-12">It is a long established fact that a reader will be distracted by the
                                readable content of a page when
                                looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less
                                normal
                                distribution of letters, as opposed to using</p>
                        </div>
                        <div className="card mb-16 border-0 me-16">
                            <div className="d-flex mb-10">
                                <img src="avatar_icon.jpg" alt="user-image" width="37" height="37"
                                    className="rounded-circle me-13" />
                                <h5 className="d-flex align-items-center m-0">Procure AI</h5>
                            </div>
                            <p className="fs-12">It is a long established fact that a reader will be distracted by the
                                readable content of a page when
                                looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less
                                normal
                                distribution of letters, as opposed to using</p>
                        </div>
                        <div className="card mb-16 border-0 me-16">
                            <div className="d-flex mb-10">
                                <img src="avatar_icon.jpg" alt="user-image" width="37" height="37"
                                    className="rounded-circle me-13" />
                                <h5 className="d-flex align-items-center m-0">Procure AI</h5>
                            </div>
                            <p className="fs-12">It is a long established fact that a reader will be distracted by the
                                readable content of a page when
                                looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less
                                normal
                                distribution of letters, as opposed to using</p>
                        </div> */}
                    </div>
                </div>
                <div id="nav-2" className="ms-56 tab-pane"></div>

            </div>
        </div>
    </Layout>;
};

export default WelcomePage;
